export interface DomainOption {
    value: string;
    label: string;
  }

export const domainOptions: DomainOption[] = [
    { value: "tamdagroup.eu", label: "tamdagroup.eu" },
    { value: "tamdafoods.eu", label: "tamdafoods.eu" },
    { value: "tamdaoc.eu", label: "tamdaoc.eu" },
    { value: "tamdamedia.eu", label: "tamdamedia.eu" },
    { value: "tamdaexpress.eu", label: "tamdaexpress.eu" },
  ]